module.exports = __webpack_public_path__ + "static/img/logoY.620ea42.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/logoY.png
// module id = dNxz
// module chunks = 1